/**
 * Safely cast unknown API data to a Record<string, unknown>.
 * Returns an empty record when the input is not a plain object.
 */
export function asRecord(input: unknown): Record<string, unknown> {
  if (input && typeof input === "object" && !Array.isArray(input)) {
    return input as Record<string, unknown>;
  }
  return {};
}

/**
 * Safely cast unknown API data to an array of records.
 * Filters out any items that are not plain objects.
 */
export function asArray(input: unknown): Record<string, unknown>[] {
  if (Array.isArray(input)) {
    return input.filter(
      (item): item is Record<string, unknown> =>
        Boolean(item && typeof item === "object" && !Array.isArray(item)),
    );
  }
  return [];
}
